import { PropertyEmailLookupModelDto } from "./../lookup/property.lookup-email.model";
import { IPropertyAutoComplete } from "./../property/property-autocomplete.model";
import { IPersonAutoComplete } from "./../autocomplete/person.autocomplete.model";
import { BaseModel } from "../base-model";
import { ItemStateModel } from "../base-itemstate";
import {
    ReportEmailLookupInfoDto,
    ReportEmailServerLookupInfoDto,
    ReportMediaLookupInfoDto,
    ReportMessageFolderLookupInfoDto,
    ReportMessageLookupInfoDto,
    ReportPublisherLookupInfoDto,
    ReportTemplateLookupInfoDto,
    ReportDocumentModelDto,
    ReportUserLookupInfoDto,
    SendEmailOrderInforDto,
    SendEmailSmsMessageDto
} from ".";
import { IDemandAutoComplete } from "../autocomplete";
import { ReportServices } from "../../services/report.services";
import { IGenericObject } from "../common";

export interface IReportSendEmailModel extends ItemStateModel {
    /** send message or malling */
    IsMailling?: boolean;

    PropertyDisabled?: boolean;
    PersonDisabled?: boolean;
    BccOptionId?: number;
    Attachment1Id?: number;
    Attachment2Id?: number;
    BccEmails?: string;
    CcEmails?: string;
    EmailServerId?: number;
    HtmlFileBase64?: string;
    IsNotUseEmailTemplate?: boolean;
    IsRequestDeliveryReceipt?: boolean;
    IsRequestReadReceipt?: boolean;
    IsTrackEmails?: boolean;
    IsUseHtmlFile?: boolean;
    LookupInfos?: SendEmailLookupInfosDto;
    MediaId?: number;
    MessageId?: number;
    Module?: number;
    OtherInfos?: SendEmailOrderInforDto;

    PropertyIds?: number[];
    PersonIds?: number[];
    DemandIds?: number[];
    Emails?: string[];


    ReportIds?: number[];
    ReportReferences?: string;
    SendSmsId?: number;
    ShowAddressId?: number;
    ShowPriceId?: number;
    SmsMessage?: SendEmailSmsMessageDto;

    /** SUPPORT MULTI LANGUAGE */
    SubjectEN?: string;
    SubjectFR?: string;
    SubjectNL?: string;
    LangId?: number;

    ToEmails?: string;
    UserId?: number;
    DocumentIds?: any;
    Documents?: ReportDocumentModelDto[];
    AttachDocuments?: any;
    //
    PropertyInfos?: IPropertyAutoComplete[];
    PersonInfos?: Array<IPersonAutoComplete>;
    DemandInfos?: Array<IDemandAutoComplete>;
    PropertyReferences?: string;

    //
    ChangeInfoAction?: string;
    EmailLookups: PropertyEmailLookupModelDto[];
    HtmlContent?: string;
    IsOwner?: boolean;
    IsActualTenant?: boolean;

    HtmlContents?: CustomHtmlContent[];
    isInit?: boolean;
    PropertyPictures?: any;
    AppointmentIds?: number[];

    TemplateEN?: string;
    TemplateFR?: string;
    TemplateNL?: string;

    PersonInfoInValids?: any;
    DemandInfoInValids?: any;
    BCCIds: number[];
    CCIds: number[];
    PaymentRequestId?: number;
}

export class ReportSendEmailModel extends BaseModel<IReportSendEmailModel> implements IReportSendEmailModel {
    /** send message or malling */
    IsMailling?: boolean;

    PropertyDisabled?: boolean;
    PersonDisabled?: boolean;
    BccOptionId?: number;
    Module: number;
    Attachment1Id?: number;
    Attachment2Id?: number;

    ToEmails?: string;
    BccEmails?: string;
    CcEmails?: string;

    EmailServerId?: number;
    HtmlFileBase64?: string;
    IsNotUseEmailTemplate?: boolean;
    IsRequestDeliveryReceipt?: boolean;
    IsRequestReadReceipt?: boolean;
    IsTrackEmails?: boolean;
    IsUseHtmlFile?: boolean;
    LookupInfos?: SendEmailLookupInfosDto;
    MediaId?: number;
    MessageId?: number;
    OtherInfos?: SendEmailOrderInforDto;

    PropertyIds?: number[];
    PersonIds?: number[];
    DemandIds?: number[];

    ReportIds?: number[];
    ReportReferences?: string;
    SendSmsId?: number;
    ShowAddressId?: number;
    ShowPriceId?: number;
    SmsMessage?: SendEmailSmsMessageDto;

    /** SUPPORT MULTI LANGUAGE */
    SubjectEN?: string;
    SubjectFR?: string;
    SubjectNL?: string;
    LangId?: number;

    UserId?: number;
    DocumentIds?: any;

    //
    PropertyInfos?: IPropertyAutoComplete[];
    PersonInfos?: IPersonAutoComplete[];
    DemandInfos?: IDemandAutoComplete[];
    AttachDocuments?: any;

    PropertyReferences?: string;
    EmailLookups: PropertyEmailLookupModelDto[];

    //
    ChangeInfoAction?: string;
    HtmlContent?: string;
    IsOwner?: boolean;
    IsActualTenant?: boolean;
    HtmlContents?: CustomHtmlContent[];
    isInit?: boolean;
    PropertyPictures?: any;
    AppointmentIds?: number[];
    TemplateEN?: string;
    TemplateFR?: string;
    TemplateNL?: string;
    PersonInfoInValids?: any;
    DemandInfoInValids?: any;
    BCCIds: number[];
    CCIds: number[];
    PaymentRequestId?: number;
    constructor(option?: IReportSendEmailModel) {
        super(option);
        this.PropertyIds = this.PropertyIds || [];
        this.PersonIds = this.PersonIds || [];
        this.DemandIds = this.DemandIds || [];
        this.ReportIds = this.ReportIds || [];
        this.DocumentIds = this.DocumentIds || [];

        this.PropertyInfos = this.PropertyInfos || [];
        this.PersonInfos = this.PersonInfos || [];
        this.DemandInfos = this.DemandInfos || [];

        this.PropertyReferences = this.PropertyReferences || null;
        this.ChangeInfoAction = this.ChangeInfoAction || "INIT";
        this.EmailLookups = this.EmailLookups || [];
        this.LookupInfos = this.LookupInfos || new SendEmailLookupInfosDto
        this.ToEmails = this.ToEmails || "";
        this.CcEmails = this.CcEmails || "";
        this.BccEmails = this.BccEmails || "";
        this.SubjectEN = this.SubjectEN || null;
        this.SubjectFR = this.SubjectFR || null;
        this.SubjectNL = this.SubjectNL || null;
        this.LangId = this.LangId || null;
        this.IsMailling = this.IsMailling || null;
        this.HtmlContent = this.HtmlContent || null;
        this.IsOwner = this.IsOwner || false;
        this.IsActualTenant = this.IsActualTenant || false;
        this.AttachDocuments = this.AttachDocuments || [];
        this.PropertyDisabled = this.PropertyDisabled || false;
        this.PersonDisabled = this.PersonDisabled || false;
        this.HtmlContents = this.HtmlContents || [];
        this.isInit = this.isInit || false;
        this.PropertyPictures = this.PropertyPictures || [];
        this.AppointmentIds = this.AppointmentIds || [];
        this.TemplateEN = this.TemplateEN || null;
        this.TemplateFR = this.TemplateFR || null;
        this.TemplateNL = this.TemplateNL || null;
        this.PersonInfoInValids = this.PersonInfoInValids || [];
        this.DemandInfoInValids = this.DemandInfoInValids || [];
        this.BCCIds = this.BCCIds || [];
        this.CCIds = this.CCIds || [];
        this.PaymentRequestId = this.PaymentRequestId || null;
    }
}

export class SendEmailLookupInfosDto {
    Emails: ReportEmailLookupInfoDto[];
    EmailServers: ReportEmailServerLookupInfoDto[];
    Media: ReportMediaLookupInfoDto[];
    MessageFolders: ReportMessageFolderLookupInfoDto[];
    Messages: ReportMessageLookupInfoDto[];
    Publishers: ReportPublisherLookupInfoDto[];
    Templates: ReportTemplateLookupInfoDto[];
    Users: ReportUserLookupInfoDto[];
    Documents?: ReportDocumentModelDto[];
    BccOptions?: IGenericObject[]
    /**
     *
     */
    constructor() {
        this.Emails = [];
        this.EmailServers = [];
        this.Media = [];
        this.MessageFolders = [];
        this.Messages = [];
        this.Publishers = [];
        this.Templates = [];
        this.Users = [];
        this.BccOptions = [];
    }
}

export class SendEmailStatusResultDto {
    Code: number
    PersonId: number
    PersonIdent: string
    PersonEmail: string
    Message: string
    /** The rendered mail of a preview session (Code 0). */
    HtmlContent?: string
}

export class CustomHtmlContent {
    DemandId?: number;
    PersonId?: number;
    HtmlContent?: string;
    MessageTitle?: string;
    constructor(option?: any) {
        this.DemandId = option.DemandId || null;
        this.PersonId = option.PersonId || null;
        this.HtmlContent = option.HtmlContent || null;
        this.MessageTitle = option.MessageTitle || null;
    }


}

const MAX_REQUEST_RETRY_NUMBER = 60;
export class HtmlContentModel {
    PersonId?: number; // will remove after update done
    DemandId?: number; // will remove after update done
    content?: string; // will remove after update done
    clientId: number;
    moduleType?: number;
    clientInfo?: any;
    isLoading?: boolean = false;
    MessageTitle?: string = null;
    result?: {
        error?: string,
        htmlContent?: string
    };
    startTime?: string;
    sessionId?: string;
    private service?: ReportServices;
    getHtmlContentInterval?: any = null;
    private retry: number;
    constructor(option?: any) {
        this.result = {
            error: null,
            htmlContent: ''
        };
        this.service = new ReportServices();
        this.sessionId = option.sessionId || null;
        this.getHtmlContentInterval = null;
        Object.assign(this, option);
    }
    get clientTabInfo() {
        return this.clientInfo.Reference || this.clientInfo.Email; //may check by module type later.
    }

    startPreviewJob() {
        this.isLoading = true;
        this.retry = 0;
        this.getHtmlContentInterval = setInterval(() => {
            this.retry++;
            this.service.getHtmlContent(this.sessionId).then(async (response: any) => {
                if (response && response.Code === 0) {
                    this.stopPreviewJob();
                    this.result = {
                        error: null,
                        htmlContent: response.HtmlContent.replace(/<a /g, '<a target =\"_blank\" ') // WA-3143 improve to open new browser
                    }
                    this.isLoading = false;

                } else if (this.retry >= MAX_REQUEST_RETRY_NUMBER) {
                    this.stopPreviewJob();
                    this.result = {
                        error: 'end call request get html content with no result',
                        htmlContent: 'end call request get html content with no result'
                    }
                    this.isLoading = false;
                    console.log('end call request get html content with no result');
                }
            }).catch(ex => {
                this.stopPreviewJob();
                this.result = {
                    error: 'end call request get html content with no result',
                    htmlContent: 'end call request get html content with no result'
                }
                this.isLoading = false;
            });
        }, 700)
        
    }
    reset() {
        this.result.error = null;
        this.result.htmlContent = null;
        this.getHtmlContentInterval = null;
    }
    stopPreviewJob() {
        clearInterval(this.getHtmlContentInterval);
    }
}